import React from 'react';
import { bool, func, oneOf } from 'prop-types';

import classes from './ActionBarItem.module.css';

const Types = [
    'add',
    'back',
    'data',
    'delete',
    'edit',
    'exclude',
    'include',
    'profile',
    'refresh',
    'save',
    'swap',
    'trend',
    'unsubscribe'
];
const Icons = Types.reduce((types, type) => ({
    ...types,
    [type]: `/assets/images/actionBarItem-${type}.svg`
}), {});

const ActionBarItem = ({ children, disabled, hidden, iconSrc, onClick, type }) => {
    if (hidden) {
        return null;
    }
    let icon = null;
    iconSrc || (iconSrc = Icons[type]);
    if (iconSrc) {
        icon = (
            <img alt="" className={classes.icon} src={iconSrc} />
        );
    }
    return (
        <button
            className={classes.button}
            disabled={disabled}
            onClick={onClick}
            type="button"
        >
            {icon}
            {children}
        </button>
    );
};

ActionBarItem.defaultProps = {
    disabled: false
};

ActionBarItem.propTypes = {
    disabled: bool,
    onClick:  func.isRequired,
    type:     oneOf(Types)
};

export default ActionBarItem;
